import React, { Fragment } from 'react';

import * as Actions from './actions';

const EmployeesActions = ({ company, subcompany, permissions, employee, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.custom_employee.toggle'] && (
        <Actions.Toggle employee={employee} handleClick={handleToggle} />
      )}
      {permissions['acl.custom_employee.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          employee={employee}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default EmployeesActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/list/EmployeesActions.js